import { render, staticRenderFns } from "./main-right-middle-bar.vue?vue&type=template&id=6b579f72&scoped=true"
import script from "./main-right-middle-bar.vue?vue&type=script&lang=js"
export * from "./main-right-middle-bar.vue?vue&type=script&lang=js"
import style0 from "./main-right-middle-bar.vue?vue&type=style&index=0&id=6b579f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b579f72",
  null
  
)

export default component.exports